import { FormEvent, useState } from 'react'
import type { Session } from '@supabase/supabase-js'
import { supabase } from '../lib/supabase'
import { useAuth } from '../auth/AuthProvider'

export function ForcePasswordChange({ session }: { session: Session }) {
  const { signOut } = useAuth()
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(event: FormEvent) {
    event.preventDefault()
    setError('')

    if (password.length < 8) {
      setError('A nova senha deve ter pelo menos 8 caracteres.')
      return
    }
    if (password !== confirmPassword) {
      setError('As senhas informadas não coincidem.')
      return
    }

    setSaving(true)
    try {
      const response = await fetch('/api/auth/password', {
        method: 'POST',
        headers: {
          authorization: `Bearer ${session.access_token}`,
          'content-type': 'application/json',
        },
        body: JSON.stringify({ password }),
      })

      const data = await response.json() as { error?: string; ok?: boolean }
      if (!response.ok) throw new Error(data.error || 'Não foi possível atualizar a senha.')

      const email = session.user.email
      if (!email) {
        throw new Error('Senha atualizada com sucesso. Saia e entre novamente com sua nova senha.')
      }

      const nextSession = await supabase.auth.signInWithPassword({ email, password })
      if (nextSession.error) {
        throw new Error('Senha atualizada com sucesso, mas não foi possível renovar a sessão. Saia e entre novamente com sua nova senha.')
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Não foi possível atualizar a senha.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <main className="login-page">
      <section className="login-card" aria-labelledby="password-change-title">
        <div className="brand-mark">AGB</div>
        <p className="eyebrow">SEGURANÇA DA CONTA</p>
        <h1 id="password-change-title">Crie sua senha definitiva</h1>
        <p className="muted">Você entrou com uma senha temporária. Antes de acessar o Suite, defina uma nova senha pessoal.</p>

        <form className="login-form" onSubmit={handleSubmit}>
          <label>
            Nova senha
            <input
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              minLength={8}
              required
              disabled={saving}
            />
          </label>

          <label>
            Confirmar nova senha
            <input
              type="password"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              minLength={8}
              required
              disabled={saving}
            />
          </label>

          <div className="notice info">Use pelo menos 8 caracteres. Evite reutilizar senhas de outros sistemas.</div>
          {error && <div className="notice error" role="alert">{error}</div>}

          <button className="primary-button" type="submit" disabled={saving}>
            {saving ? 'Atualizando...' : 'Salvar nova senha e entrar'}
          </button>
          <button className="text-button" type="button" disabled={saving} onClick={() => void signOut()}>Sair</button>
        </form>
      </section>
    </main>
  )
}
